var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerkehr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Verkehr__Icn/40px/Legende/Verkehr",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Verkehr__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Legende_Verkehr__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.95758779,10.3869305 L21.7746435,29.8686847 L20.2219514,31.1293011 L4.40489691,11.6475459 L5.95758779,10.3869305 Z M13.2765013,10.3709798 L22.6628969,22.0029798 L34.4,13.2 L35.6,14.8 L23.9198969,23.5599798 L28.6059383,29.3664848 L27.049532,30.62251 L11.7200927,11.6270068 L13.2765013,10.3709798 Z",
    id: ".._.._src_svg_Icn_40px_Legende_Verkehr__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerkehr);
export default __webpack_public_path__ + "static/media/Verkehr.9457863a15879af22b8f75aae37897fc.svg";
export { ForwardRef as ReactComponent };